<template>
  <div class="">
    <div class="bg-scroll bg-center bg-cover instructors">
      <h1 class="is-size-1 has-text-white font-second--bold">
        Meet the Instructors
      </h1>
    </div>
    <div class="instructors-main">
      <div class="columns">
        <div class="column is-6">
          <div class="card instructor-card">
            <div class="card-image fuller instructor-image bg-cover"></div>
            <div class="card-content">
              <p class="title is-4 font-main">Russell Fuller</p>
              <div class="content bio">
                For the last 22 years, Dr. Fuller taught at The Southern Baptist
                Seminary in Louisville, Kentucky, where Dr. Fuller taught Old
                Testament, especially, Hebrew and Aramaic. Dr. Fuller is the
                author of Introduction to Biblical Hebrew and Introduction to
                Biblical Hebrew Syntax. Before coming to Southern Seminary, he
                taught Old and New Testament at Mid-Continent College in
                Mayfield, Kentucky for two years. His beliefs and teachings are
                consistent with The Baptist Confession of Faith 1689.
              </div>
            </div>
            <div class="card-footer">
              <div class="card-footer-item">rtffuller@gmail.com</div>
            </div>
          </div>
        </div>
        <div class="column is-6">
          <div class="card instructor-card">
            <div class="card-image choi instructor-image bg-cover"></div>
            <div class="card-content">
              <p class="title is-4 font-main">Kyoungwon Choi</p>
              <div class="content bio">
                Kyoungwan Choi is the co-author of Invitation to Biblical Hebrew
                and Invitation to Biblical Hebrew Syntax with Dr. Russell
                Fuller. He graduated from The Southern Baptist Theological
                Seminary with M. Div. and Ph.D. degrees. He also attended The
                Hebrew Union College-Jewish Institute of Religion, learning
                Aramaic, Syriac, and Arabic from Dr. Isaac Jerusalmi. After
                teaching to Temple Baptist Seminary in Chattanooga, Tennessee,
                he has served churches in Korea.
              </div>
            </div>
            <div class="card-footer">
              <div class="card-footer-item">kchoi5730@gmail.com</div>
            </div>
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="column is-6">
          <div class="card instructor-card">
            <div class="card-image mcdonald instructor-image bg-cover"></div>
            <div class="card-content">
              <p class="title is-4 font-main">Richard McDonald</p>
              <div class="content bio">
                Richard McDonald received his M. Div. and Ph. D. from the
                Southern Baptist Theological Seminary. His doctoral work, under
                the supervision of Dr. Russell Fuller, concentrated on biblical
                Hebrew grammar. He served as Dr. Fuller’s assistant for nine
                years, and has taught on the college and seminary level for six
                years. He has written various articles on Hebrew grammar and Old
                Testament interpretation.
              </div>
            </div>
            <div class="card-footer">
              <div class="card-footer-item">richardcmcd@gmail.com</div>
            </div>
          </div>
        </div>
        <div class="column is-6">
          <div class="card instructor-card">
            <div class="card-image rush instructor-image bg-cover"></div>
            <div class="card-content">
              <p class="title is-4 font-main">Tom Rush</p>
              <div class="content bio">
                Dr. Tom Rush serves an Evangelist with TREAD Ministries, Monroe, Georgia,
                and is Pastor at Bethlehem Baptist Church, Fairburn, Georgia. He is a native
                of East Point, Georgia, and a graduate of Georgia Tech (BSIM);
                 Southeastern Baptist Theological Seminary (MDiv);
                 and Immanuel Baptist Theological Seminary (DMin). He has served as a pastor
                 and evangelist for over 42 years, serving churches in North Carolina, New Mexico,
                 Florida, and Georgia. He also served as Reserve Chaplain in the Navy and Air Force,
                 serving a total of 28 years, retiring from the Air Force Reserves as a Lieutenant
                 Colonel in 2005. Among several active-duty tours, he served as the Joint Special
                 Operations Command Chaplain in Afghanistan during Operation Enduring Freedom, 2004-2005.
                 Dr. Rush is married to Lesli and they have five children and twelve grandchildren.
              </div>
            </div>
            <div class="card-footer">
              <div class="card-footer-item">drthomasrush@gmail.com</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Instructors',
}
</script>
<style lang="scss" scoped>
@import '@/assets/css/_vars.scss';
@import '@/assets/css/_colors.scss';
.instructors {
  background-image: $mask-dark, url('../assets/HebrewMan.jpg');
  position: relative;
  overflow-y: visible;
  height: 20em;
  & > h1 {
    position: absolute;
    top: 50%;
    left: 10%;
  }
}

.instructors-main {
  display: flex;
  flex-direction: column;
  padding: 2em;
  width: 100vw;
}

.fuller {
  height: 22em;
  width: clamp(15em, 16em);
  margin: 1em auto;
  border-radius: 12px;
  background-image: url('../assets/Fuller_main.jpg');
}
.mcdonald {
  height: 22em;
  width: clamp(15em, 16em);
  margin: 1em auto;
  border-radius: 12px;
  background-image: url('../assets/McDonald_main.jpeg');
  background-position: top -5em right;
}
.choi {
  height: 22em;
  width: 100%;
  margin: 1em auto;
  border-radius: 12px;
  background-image: url('../assets/Kyoungwon_Choi_main.jpg');
  background-position: top -7em right;
}
.rush {
  height: 22em;
  width: 100%;
  margin: 1em auto;
  border-radius: 12px;
  background-image: url('../assets/TomRushMain.jpeg');
}
.bio {
  min-height: 14em;
}
//fixes repeat with rush's photo
@media (max-width: 900px) {
  .rush {
    background-position: center;
  }
}
@media (min-width: 1400px) {
  .rush {
    background-position: top -18em center;
  }
  .mcdonald {
    background-position: top -9em center;
  }
}
@media (max-width: 500px) {
  .fuller,
  .choi,
  .mcdonald,
  .rush {
    background-position: center;
  }
}
</style>
